import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { IBuilderDateTime } from '@shared/interfaces';

@Component({
  selector: 'app-date-time',
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.scss'],
  standalone: false,
})
export class DateTimeComponent implements OnInit {
  @Input() dateTime: IBuilderDateTime;
  @Input() control: FormControl;
  @Output() valueChange = new EventEmitter<any>();

  today: Date = new Date();

  ngOnInit(): void {
    if (this.dateTime.isRequired) {
      this.control.setValidators([Validators.required]);
    }

    // Default current value
    if (
      // (this.dateTime.valueSource === 'time' &&
      //   this.dateTime.disallowCurrentTime === false) ||
      // (this.dateTime.valueSource === 'date' &&
      //   this.dateTime.disallowCurrentDate === false) ||
      this.dateTime.valueSource === 'datetime' &&
      (this.dateTime.disallowCurrentTime === false ||
        this.dateTime.disallowCurrentDate === false)
    ) {
      if (!this.control.value) {
        this.control.setValue(this.today);
      }
    }

    // Add past/future restrictions
    const validators = this.control.validator ? [this.control.validator] : [];

    if (
      // this.dateTime.valueSource === 'date' ||
      this.dateTime.valueSource === 'datetime'
    ) {
      if (this.dateTime.isPastDateSelected) {
        validators.push((control) =>
          control.value && control.value > this.today
            ? { futureDateNotAllowed: true }
            : null
        );
      }
      if (this.dateTime.isFutureDateSelected) {
        validators.push((control) =>
          control.value && control.value < this.today
            ? { pastDateNotAllowed: true }
            : null
        );
      }
    }

    if (
      // this.dateTime.valueSource === 'time' ||
      this.dateTime.valueSource === 'datetime'
    ) {
      if (this.dateTime.isPastTimeSelected) {
        validators.push((control) =>
          control.value &&
          new Date(control.value).getTime() > this.today.getTime()
            ? { futureTimeNotAllowed: true }
            : null
        );
      }
      if (this.dateTime.isFutureTimeSelected) {
        validators.push((control) =>
          control.value &&
          new Date(control.value).getTime() < this.today.getTime()
            ? { pastTimeNotAllowed: true }
            : null
        );
      }
    }

    this.control.setValidators(validators);
    this.control.updateValueAndValidity();

    // Emit whenever value changes
    this.control.valueChanges.subscribe((val) => {
      this.valueChange.emit(val);
    });
  }
}
